import {
  DefaultTabWrapper,
  RenderSlideMacro,
} from 'components/OrderDetails/Tabs/utilities';
import { Grid, Switch, Typography, Box } from '@mui/material';
import { OrderDetailsSlidesListView } from 'components/OrderDetails/OrderDetailsSlidesListView';
import { inlineBlockStyle } from 'components/OrderDetails/orderDetailsSlidesStyles';
import React from 'react';
import { useProcessedSlideStyles } from 'components/OrderDetails/styles';
import { NotUploadedSlidesExpansionGrid } from 'components/OrderDetails/NotUploadedSlidesGrid';
import { ShowStaffUserOnly } from 'components/ConditionalWrappers/IsStaffWrapper/ShowStaffUserOnly';
import { BatchUploadAnnotationsSection } from 'components/OrderDetails/BatchUploadAnnotationsSection';
import { nameSorter } from 'utilities/general';

export const ProcessedSlidesTab = (props) => {
  const {
    slides = [],
    isSlidesLoading,
    showFailedQCSlides,
    order,
    quickFilterText,
    onQuickFilterText,
    handleToggleShowFailedQCSlides,
    notUploadedSlides,
  } = props;

  const { classes } = useProcessedSlideStyles();

  // non-admin users won't have as many fields though
  let slidesToShow = slides;

  if (!showFailedQCSlides) {
    slidesToShow = slides.filter((slide) => !slide.failed_qc_datetime);
  }

  slidesToShow = slidesToShow.filter((slide) => slide.is_public);

  slidesToShow.sort(nameSorter);

  return (
    <DefaultTabWrapper>
      <Grid item xs={12}>
        <ShowStaffUserOnly>
          <NotUploadedSlidesExpansionGrid
            notUploadedSlides={notUploadedSlides}
          />
          <BatchUploadAnnotationsSection />
        </ShowStaffUserOnly>
        <Box className={classes.slideView}>
          <Typography variant={'h5'}>Slides</Typography>
        </Box>
        <Box mb={11}>
          <OrderDetailsSlidesListView
            order={order}
            quickFilterText={quickFilterText}
            onQuickFilterText={onQuickFilterText}
            isSlidesLoading={isSlidesLoading}
            rowData={slides}
          />
        </Box>

        <Box mt={1}>
          <Typography variant={'h5'}>Slide Thumbnails</Typography>
        </Box>

        <Box>
          <Switch
            checked={showFailedQCSlides}
            onChange={handleToggleShowFailedQCSlides}
            value="showFailedQCSlides"
          />
          <Typography variant={'body1'} style={inlineBlockStyle}>
            Show Failed QC Slides
          </Typography>
        </Box>
        <input
          className={classes.formInput}
          type="text"
          value={quickFilterText}
          onChange={onQuickFilterText}
          placeholder="Slide Name Filter ..."
        />
        <Grid container spacing={0} justifyContent="center" alignItems="center">
          {slidesToShow.map((slide) => (
            <RenderSlideMacro
              slide={slide}
              key={slide.uuid}
              quickFilterText={quickFilterText}
            />
          ))}
        </Grid>
      </Grid>
    </DefaultTabWrapper>
  );
};
